import { render } from "./ReviewModal.vue?vue&type=template&id=1c4a1eeb&scoped=true"
import script from "./ReviewModal.vue?vue&type=script&lang=js"
export * from "./ReviewModal.vue?vue&type=script&lang=js"

import "./ReviewModal.vue?vue&type=style&index=0&id=1c4a1eeb&scoped=true&lang=scss"

import exportComponent from "/Users/alex/lab_dev_test/info-global/info_front_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c4a1eeb"]])

export default __exports__